import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import {
  AuthLayout, ErrorText, InfoText, Turnstile, useAuthConfig, passwordMeetsPolicy,
  PasswordHints, input, label, button, linkRow, linkStyle,
} from './authShared';

/** Self-service registration. Cognito emails a verification code → /verify. */
export default function SignUp() {
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [exists, setExists] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setExists(false);
    if (!email.trim()) { setError('Enter your email.'); return; }
    if (!passwordMeetsPolicy(password, cfg?.passwordPolicy)) {
      setError('Please choose a password that meets the requirements above.'); return;
    }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (cfg?.captchaSiteKey && !captcha) { setError('Please complete the CAPTCHA.'); return; }
    setBusy(true);
    const r = await AuthAPI.signup(email.trim(), password, captcha);
    setBusy(false);
    if (r.ok && r.status === 'confirm') { nav(`/verify?email=${encodeURIComponent(email.trim())}`); return; }
    if (r.ok && r.status === 'exists') { setExists(true); return; }
    setError(r.message || 'Couldn’t create your account. Please try again.');
  };

  return (
    <AuthLayout title="Create your account" subtitle="Fintech Innovation Lab Portal">
      <form onSubmit={submit}>
        <label style={label}>Email
          <input style={input} type="email" autoComplete="username" value={email}
                 onChange={e => setEmail(e.target.value)} autoFocus />
        </label>
        <label style={label}>Password
          <input style={input} type="password" autoComplete="new-password" value={password}
                 onChange={e => setPassword(e.target.value)} />
        </label>
        <PasswordHints policy={cfg?.passwordPolicy} />
        <label style={label}>Confirm password
          <input style={input} type="password" autoComplete="new-password" value={confirm}
                 onChange={e => setConfirm(e.target.value)} />
        </label>
        {cfg?.captchaSiteKey && <Turnstile siteKey={cfg.captchaSiteKey} onToken={setCaptcha} />}
        {exists && (
          <InfoText>
            An account with this email already exists. Try <Link to="/login" style={linkStyle}>signing in</Link> or{' '}
            <Link to="/forgot-password" style={linkStyle}>resetting your password</Link>.
          </InfoText>
        )}
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Creating…' : 'Create account'}</button>
      </form>
      <p style={linkRow}>Already have an account? <Link to="/login" style={linkStyle}>Sign in</Link></p>
    </AuthLayout>
  );
}
